export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UploadButton.vue?vue&type=template&id=8a2157fa&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadButton.vue?vue&type=template&id=8a2157fa&scoped=true
// module id = 1564
// module chunks = 31